import registeredFunctions from './registeredFunctions'

export function registerSearchListsBuilder(id, fn) {
    registeredFunctions[id] = fn
}

export function buildSearchLists(lists) {
    Object.values(registeredFunctions).forEach((fn) => fn(lists))
}
